import { Component } from '@angular/core';
import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-callback',
  styles: [
    `
      .fast-right-spinner {
        -webkit-animation: spin-r 1s infinite linear;
        animation: spin-r 1s infinite linear;
      }
      @-webkit-keyframes spin-r {
        0% {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(359deg);
          transform: rotate(359deg);
        }
      }
      i.fa-fw.fa-spinner.fast-right-spinner {
        padding-right: 0px;
      }
      h1 {
        color: #3e4543;
      }
    `
  ],
  template: `
    <h1>redirecting <i class="fa fa-fw fa-spinner fast-right-spinner"></i></h1>
  `
})
export class CallbackComponent {
  constructor(private authService: AuthService) {
    this.authService.handleAuth();
  }
}
